import axiosInstance from "src/Funcs/axiosFuncs/axiosInstance";
import { API } from "src/Funcs/APIFuncs/APIFunc";
import { toast } from "react-toastify";
import { lang } from "src/Funcs/lang";

export const HABITS_LOAD_REQUEST = "HABITS_LOAD_REQUEST";
export const HABITS_LOAD_SUCCESS = "HABITS_LOAD_SUCCESS";
export const HABITS_LOAD_FAIL = "HABITS_LOAD_FAIL";
export const HABIT_CREATE_SUCCESS = "HABIT_CREATE_SUCCESS";
export const HABIT_UPDATE_SUCCESS = "HABIT_UPDATE_SUCCESS";
export const HABIT_DELETE_SUCCESS = "HABIT_DELETE_SUCCESS";
export const HABIT_CHECKIN_SUCCESS = "HABIT_CHECKIN_SUCCESS";
export const HABIT_STATS_SUCCESS = "HABIT_STATS_SUCCESS";
export const HABIT_DAILY_REPORTS_SUCCESS = "HABIT_DAILY_REPORTS_SUCCESS";

function getErrorMessage(err, fallback) {
  return err?.response?.data?.message || err?.message || fallback;
}

export const getBoardHabitsAction = ({ BoardID, mine = false }) => async (dispatch) => {
  dispatch({ type: HABITS_LOAD_REQUEST });
  try {
    const { data } = await axiosInstance.get(`${API}habits/${BoardID}`, {
      params: mine ? { mine: 1 } : undefined,
    });
    dispatch({ type: HABITS_LOAD_SUCCESS, payload: data });
  } catch (err) {
    dispatch({ type: HABITS_LOAD_FAIL, payload: getErrorMessage(err, "Load failed") });
  }
};

export const addHabitAction = ({ BoardID, body }) => async (dispatch) => {
  try {
    const { data } = await axiosInstance.post(`${API}habits/${BoardID}`, body);
    toast.success(lang("AddedSuccessfully"));
    dispatch({ type: HABIT_CREATE_SUCCESS, payload: data });
    return true;
  } catch (err) {
    toast.error(getErrorMessage(err, "Add failed"));
    return false;
  }
};

export const updateHabitAction = ({ BoardID, HabitID, body }) => async (dispatch) => {
  try {
    const { data } = await axiosInstance.put(
      `${API}habits/${BoardID}/${HabitID}`,
      body,
    );
    toast.success(lang("EditedSuccessfully"));
    dispatch({ type: HABIT_UPDATE_SUCCESS, payload: data });
    return true;
  } catch (err) {
    toast.error(getErrorMessage(err, "Update failed"));
    return false;
  }
};

export const deleteHabitAction = ({ BoardID, HabitID }) => async (dispatch) => {
  try {
    await axiosInstance.delete(`${API}habits/${BoardID}/${HabitID}`);
    toast.success(lang("DeletedSuccessfully"));
    dispatch({ type: HABIT_DELETE_SUCCESS, payload: String(HabitID) });
    return true;
  } catch (err) {
    toast.error(getErrorMessage(err, "Delete failed"));
    return false;
  }
};

export const checkInHabitAction = ({
  BoardID,
  HabitID,
  ActionID,
  outcome = "success",
  rating,
  note,
}) => async (dispatch) => {
  try {
    const { data } = await axiosInstance.post(
      `${API}habits/${BoardID}/${HabitID}/actions/${ActionID}/check-in`,
      { outcome, rating, note },
    );
    toast.success(lang("Completed"));
    dispatch({ type: HABIT_CHECKIN_SUCCESS, payload: { habitId: String(HabitID), actionId: String(ActionID), data } });
    return true;
  } catch (err) {
    toast.error(getErrorMessage(err, "Check-in failed"));
    return false;
  }
};

export const getHabitStatsAction = ({ BoardID }) => async (dispatch) => {
  try {
    const { data } = await axiosInstance.get(`${API}habits/${BoardID}/stats`);
    dispatch({ type: HABIT_STATS_SUCCESS, payload: data });
  } catch (err) {
    toast.error(getErrorMessage(err, "Stats failed"));
  }
};

export const getHabitDailyReportsAction = ({ BoardID, userId, since, until }) => async (dispatch) => {
  try {
    const params = {};
    if (userId) params.userId = userId;
    if (since) params.since = since;
    if (until) params.until = until;
    const { data } = await axiosInstance.get(
      `${API}habits/${BoardID}/habit-daily-reports`,
      { params },
    );
    dispatch({ type: HABIT_DAILY_REPORTS_SUCCESS, payload: data });
  } catch (err) {
    toast.error(getErrorMessage(err, "Failed to load habit reports"));
  }
};

